import React from 'react';
import { useNavigate } from 'react-router-dom';
import { capitalizeFirstLetter } from './funcs';
import { Photo } from './Photo';

interface QuestCardProps{
    id: string;
    image?: string;
    title?: string;
    description?: string;
    date?: string;
    steps?: number;
    experience?: number;
}

export const QuestCard = ({
    id,
    ...props
}: QuestCardProps) => {
    const navigate = useNavigate();
    return <div className='flex gap-7 hover:-translate-y-5 transition-transform cursor-pointer' onClick={() => {
        navigate(`/quest/${id}`)
    }}>
        {props.image ? <Photo src={props.image} variant="square"/> : null}
        <div className="flex flex-col justify-between">
            <div>
                <div className='flex gap-5'>
                    {props.date ? <p className='text-gray-500'>{capitalizeFirstLetter(props.date)}</p> : null}
                    {props.steps ? <p className='text-gray-500'>{props.steps} шагов</p> : null}
                </div>
                {props.title ? <p className="text-2xl">{props.title}</p> : null}
                {props.description ? <p className="text-lg">{props.description}</p> : null}
            </div>
            {props.experience ? <p className='text-gray-500'>+ {props.experience} очков опыта</p> : null}
        </div>
    </div>
}